import { createGenericFetchMachine } from '@/common/overmind/machines/generic-fetch-machine';
import type { SearchResult } from '@/overmind/effects/adapters/baseadapter';

import * as actions from './actions';

const state = createGenericFetchMachine<SearchResult[]>();

export { state, actions };
